import moment from 'moment';

class TemplateClass {

    active = null;
    category = null;
    date = null;
    description = null;
    id = null;
    props = {};
    questions = [];
    request_demo = null;
    title = null;
    used_by = null;

    constructor() {
        return this;
    }

    create = (props = {}) => {
        this.active = props.active;
        this.category = props.category;
        this.date = props.date && moment(props.date);
        this.description = props.description;
        this.id = props.id;
        this.props = props.props || {};
        this.questions = props.questions ? props.questions.map(question => new TemplateQuestionClass().create(question)) : [];
        this.request_demo = props.request_demo;
        this.title = props.title;
        this.used_by = props.used_by || 0;
        return this;
    }
}

class TemplateQuestionClass {

    id = null;
    required = null;
    type = null;
    title = null;
    props = {};
    order_index = null;

    constructor() {
        return this;
    }

    create = (props = {}) => {
        this.id = props.id;
        this.required = props.required;
        this.type = props.type;
        this.title = props.title;
        this.props = props.props || {};
        this.order_index = props.order_index;
        return this;
    }
}

export default {
    create: props => new TemplateClass().create(props),
    Question: {
        create: props => new TemplateQuestionClass().create(props),
        type: {
            list: 1,
            checkboxes: 2,
            picker: 3,
            textfield: 4,
            textview: 5,
            file_picker: 6
        }
    }
}
